module.exports = __webpack_public_path__ + "static/img/ck.960a7b5a.svg";